export const mainMenu = [{
  title: '首页',
  key: 'welcome',
  component: () => import( /* webpackChunkName: "pages" */ '@/views/welcome/Welcome'),
  icon: 'el-icon-coffee-cup'
}]

export const otherMenu = [{
  title: '详情',
  key: 'detail',
  component: () => import( /* webpackChunkName: "pages" */ '@/views/detail/Detail'),
  isMulti: true
}]

export default {
  mainMenu,
  otherMenu
}



// WEBPACK FOOTER //
// ./src/config/menu.js